import React, { FC } from "react";
import { FaTrashCan } from "react-icons/fa6";

import { SettingsConfirmModal } from "../../../components/modal/SettingsConfirmModal";
import { WorkModel } from "../../../factories/works/models/work.model";

type Props = {
  isOpen: boolean;
  selectedWorks: WorkModel[];
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
  isLoading?: boolean;
};

export const WorksDeleteConfirmModal: FC<Props> = ({
  isOpen,
  selectedWorks,
  onClose,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) return null;

  const isMultiple = selectedWorks.length > 1;

  return (
    <SettingsConfirmModal
      onClose={onClose}
      onConfirm={() => void onConfirm()}
      icon={<FaTrashCan size={18} />}
      title={isMultiple ? "Delete selected works?" : "Delete selected work?"}
      description={
        isMultiple
          ? "Selected archived works will be permanently deleted."
          : "Selected archived work will be permanently deleted."
      }
      confirmText={"Delete"}
      variant={"danger"}
      isLoading={isLoading}
    />
  );
};
